module.exports = __webpack_public_path__ + "4da8b6fc5061f975364e09fb1be878ff.pdf";